import { css, type Theme } from "@emotion/react";

export const scrollContainer = css`
  display: flex;
  flex-direction: column;
  max-height: 30rem;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  margin-right: -0.5rem;
`;

export const observe = css`
  margin: 0.5rem 0;
`;

export const accordion = {
  wrapper: (theme: Theme) => css`
    padding: 0;
    border: none;
    position: relative;
    > div {
      height: 2.5rem;
      > div {
        max-width: calc(100% - 2rem);
      }
    }
    &::after {
      content: "+";
      color: ${theme.text.body};
      position: absolute;
      top: 0.5rem;
      right: 0.25rem;
      width: 1rem;
      text-align: center;
      pointer-events: none;
    }
  `,
  open: css`
    &::after {
      content: "-";
    }
  `,
  expanded: css`
    > div {
      padding: 0;
    }
  `,
  chevron: css`
    svg {
      opacity: 0;
    }
  `,
};

export const checkboxContainer = css`
  margin: 0.25rem 0;
  height: 2rem;
  div:last-of-type {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const childCheckbox = css`
  padding-left: 1.5rem;
`;

export const grandChildCheckbox = css`
  padding-left: 3rem;
`;
